import { ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { Navigation } from '@components/common/Navigation';
import { useMenuToggle } from '@hooks/useMenuToggle';
import styles from './Layout.module.css';

interface LayoutProps {
  children: ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { isOpen, toggle, close } = useMenuToggle();

  return (
    <div className={styles.layout}>
      <Header onMenuToggle={toggle} isMenuOpen={isOpen} />

      {/* Mobile overlay */}
      <div
        className={`${styles.overlay} ${isOpen ? styles.overlayActive : ''}`}
        onClick={close}
        aria-hidden="true"
      />

      <div className={styles.container}>
        <Navigation className={isOpen ? styles.navActive : ''} isMobile={true} />

        <main className={styles.main}>{children}</main>
      </div>

      <Footer />
    </div>
  );
};
